export enum ComposerViewMode {
  TwoD = '2d',
  ThreeD = '3d'
}
